// Mugshot cards: weight pills + direct Add to cart for any [data-mug-card] on the page.
// Add posts to /cart/add and fires Horizon's CartLinesUpdateEvent so the cart drawer
// and cart count update the same way the product form does.
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__mugQuickAdd) {
  window.__mugQuickAdd = true;

  document.addEventListener('click', async (e) => {
    const pill = e.target.closest('[data-mug-card] .mug-card__pill');
    if (pill) {
      const card = pill.closest('[data-mug-card]');
      card.querySelectorAll('.mug-card__pill').forEach((p) => {
        p.classList.toggle('is-active', p === pill);
        p.setAttribute('aria-checked', p === pill);
      });
      card.querySelector('[data-out-price]').textContent = pill.dataset.price;
      card.querySelector('[data-out-compare]').textContent = pill.dataset.compare;
      const off = card.querySelector('[data-out-off]');
      if (off) { off.textContent = pill.dataset.off ? `${pill.dataset.off}% OFF` : ''; off.hidden = !pill.dataset.off; }
      const add = card.querySelector('[data-mug-add]');
      if (add) add.dataset.id = pill.dataset.id;
      return;
    }

    const btn = e.target.closest('[data-mug-add]');
    if (!btn || btn.disabled) return;
    const text = btn.querySelector('[data-add-text]');
    const idle = text.textContent;
    btn.disabled = true;
    text.textContent = 'Adding…';

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId).filter(Boolean);
    const body = new FormData();
    body.append('id', btn.dataset.id);
    body.append('quantity', '1');
    if (sectionIds.length) body.append('sections', sectionIds.join(','));

    const deferred = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: btn.dataset.id, quantity: 1 }],
      promise: deferred.promise,
    }));

    try {
      const res = await fetch(`${Theme.routes.cart_add_url}`, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      }).then((r) => r.json());
      const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'mug-card',
          sourceId: btn.dataset.id,
          itemCount: 1,
          productId: btn.dataset.productId,
          sections: res.sections,
          didError: Boolean(res.status),
        },
      });
      text.textContent = res.status ? (res.description || 'Unavailable') : 'Added ✓';
    } catch (err) {
      deferred.reject(err);
      text.textContent = 'Try again';
    }
    setTimeout(() => { text.textContent = idle; btn.disabled = false; }, 1600);
  });
}
